
import Model from './Model'
import { deburr } from 'lodash'

export default class Customer extends Model {
  constructor (attributes = {}) {
    super(attributes.id)
    this.active = Boolean(attributes.active ?? 1)

    this.name = attributes.name || null
    this.last_name = attributes.last_name || null

    // ADDRESS
    this.address = attributes.address || null
    this.postalCode = attributes.postalCode || null
    this.state = attributes.state || null
    this.city = attributes.city || null
    this.country = attributes.country || null

    this.nif = attributes.nif || null
    this.email = attributes.email || null
    this.extra_id = attributes.extra_id || null
    this.intouch_id = attributes.intouch_id || null
    this.notes = attributes.notes || null
    this.phone = attributes.phone || null

    this.invoiceable = Boolean(attributes.invoiceable)

    this._haystack = [
      attributes.name,
      attributes.last_name,
      attributes.nif,
    ].filter(attribute => attribute !== null)
      .join(' ')
      .toLowerCase()
      .split(/\s+/)
      .filter(word => word.length >= 2)
      .map(word => deburr(word))
  }

  get fullName () {
    return this.last_name ? `${this.name} ${this.last_name}` : this.name
  }

  contains (needle) {
    return needle
      .toLowerCase()
      .split(/\s+/)
      .map(word => deburr(word))
      .every(word => this._haystack
        .some(straw => straw.startsWith(word))
      )
  }

  toJSON () {
    const { _haystack: _, ...json } = this // extract properties using deconstruct syntax

    return json
  }
}
